import { inject, Injectable } from '@angular/core';
import { ApiHttpService } from '../../api-http.service';
import { ClientQuoteItem, CustomHttpResponse } from '../../../models';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ClientQuoteItemService {
  apiService: ApiHttpService<ClientQuoteItem> = inject(ApiHttpService<ClientQuoteItem>);

  getClientQuoteItemsForClientQuote(iri: string) {
    return this.apiService
      .getMany(`${iri}/client_quote_items`)
      .pipe(map(result => result.body['hydra:member']));
  }

  create(clientQuoteItem: ClientQuoteItem) {
    return this.apiService
      .post(`/client_quote_items`, clientQuoteItem)
      .pipe(map((result: CustomHttpResponse<ClientQuoteItem>) => result.body));
  }

  update(iri: string, updatedRecord: Partial<ClientQuoteItem>) {
    return this.apiService
      .patch(iri, updatedRecord as unknown as ClientQuoteItem)
      .pipe(map((result: CustomHttpResponse<ClientQuoteItem>) => result.body));
  }

  delete(iri: string) {
    return this.apiService.delete(iri).pipe(map((result) => result));
  }
}
